import type { ReturnRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

interface UseEditReturnRequestCustomerParams {
	onSuccess: (returnRequest: ReturnRequestDto) => void;
}

export default function useEditReturnRequestCustomer(
	params: UseEditReturnRequestCustomerParams,
) {
	return useApiMutation(
		"patch",
		"/shops/{shopId}/return-requests/{returnRequestId}/customer",
		{
			onSuccess: (returnRequest: ReturnRequestDto) => {
				params.onSuccess(returnRequest);
			},
		},
	);
}
